import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useContext } from 'react';

import Button from 'Common/Button';

import { AssigmentPositionContext } from '../../assigment-position.context';
import AssigmentPositionForm from '../form';

export default function Add() {
  const { setNewDialogOpened, newDialogOpened, reload } = useContext(AssigmentPositionContext);
  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await reload();
      }
      setNewDialogOpened(false);
    },
    [reload, setNewDialogOpened]
  );

  const onClick = () => {
    setNewDialogOpened(true);
  };
  return (
    <>
      <header className="text-right mt-2 mb-2">
        <Button startIcon={<AddIcon />} color="primary" onClick={onClick} className="ml-1">
          Göreve göre kkd atama ekle
        </Button>
      </header>
      <AssigmentPositionForm onClose={closeDialog} data={null} open={newDialogOpened} />
    </>
  );
}
